"use client";

import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card } from "@/components/ui/card";
import { useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { coatColor, frameSizes } from "@/utils/items.ts";

export function PhysicalAttributesForm() {
  const { control, getValues } = useFormContext();

  const bullType = getValues("bullType");

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-center mb-6">
        Physical Attributes
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* <FormField */}
        {/* 		control={ control } */}
        {/* 		name="w120" */}
        {/* 		render={ ( { field } ) => ( */}
        {/* 				<FormItem > */}
        {/* 					<FormLabel >Weight at 120 days */}
        {/* 					            (kg)</FormLabel > */}
        {/* 					<FormControl > */}
        {/* 						<Input */}
        {/* 								type="number" */}
        {/* 								step="0.1" */}
        {/* 								placeholder="Enter weight at 120 days" */}
        {/* 								{ ...field } */}
        {/* 								onChange={ ( e ) => field.onChange ( e.target.value ? Number ( e.target.value ) : undefined ) } */}
        {/* 						/> */}
        {/* 					</FormControl > */}
        {/* 					<FormMessage /> */}
        {/* 				</FormItem > */}
        {/* 		) } */}
        {/* /> */}

        <FormField
          control={control}
          name="ww"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                EPD Weaning Weight (kg)
              </FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.1"
                  placeholder="Enter weaning weight"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value ? Number(e.target.value) : undefined,
                    )
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="pw"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                EPD Pre-weaning Weight (kg)
              </FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.1"
                  placeholder="Enter pre-weaning weight"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value ? Number(e.target.value) : undefined,
                    )
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="yw"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                EPD Yearling Weight (kg)
              </FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.1"
                  placeholder="Enter yearling weight"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value ? Number(e.target.value) : undefined,
                    )
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="pmwg"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>
                Post-Weaning Weight Gain (kg)
              </FormLabel>
              <FormControl>
                <Input
                  type="number"
                  step="0.1"
                  placeholder="Post-Weaning Weight Gain (kg)"
                  {...field}
                  onChange={(e) =>
                    field.onChange(
                      e.target.value ? Number(e.target.value) : undefined,
                    )
                  }
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="coatColor"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>Coat Color</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select coat color" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent
                  className={"overflow-y-auto z-50" + " shadow-lg bg-white"}
                >
                  {coatColor.map((option: any) => (
                    <SelectItem key={option.coatColor} value={option.coatColor}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={control}
          name="size"
          render={({ field }) => (
            <FormItem>
              <FormLabel className={"text-[#008c8fff]"}>Frame Size</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select frame size" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent
                  className={"overflow-y-auto z-50 shadow-lg bg-white"}
                >
                  {frameSizes.map((option: any) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        {bullType === "Beef Bull" && (
          <FormField
            control={control}
            name="weight"
            render={({ field }) => (
              <FormItem>
                <FormLabel className={"text-[#008c8fff]"}>
                  Weight (kg) after 12 monthes
                </FormLabel>
                <FormControl>
                  <Input
                    type="number"
                    step="0.1"
                    placeholder="Enter current weight"
                    {...field}
                    onChange={(e) =>
                      field.onChange(
                        e.target.value ? Number(e.target.value) : undefined,
                      )
                    }
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}
      </div>

      <Card className="p-4 bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700">
        <p className="text-sm text-slate-600 dark:text-slate-400">
          Physical attributes help track the animal's growth and development
          over time. Weight measurements at different stages are important
          indicators of health and productivity.
        </p>
      </Card>
    </div>
  );
}
